export const IMAGE_PREVIEW_SIZE = {
  DEFAULT: 100,
};
